<template>
  <!-- 导航容器 -->
  <div class="nav-container">
    <!-- 导航内容将由脚本动态生成 -->
  </div>
</template>

<script>
export default {
  props: {
    navConfig: {
      type: Object,
      default: () => ({
        name: 'tlbbgl',
        logos: [0, 7],
        basAlign: 'right',
        skins: [0, 'white', 0]
      })
    }
  },
  mounted() {
    this.loadNavigationScript();
  },
  methods: {
    loadNavigationScript() {
      const oldScript = document.getElementById('cyou_top');
      const oldScript2 = document.getElementById('cyou_bottom');
      if (oldScript) {
        oldScript.remove();
      }
      if (oldScript2) {
        oldScript2.remove();
      }
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//www.changyou.com/js/cyou_public.js';
      script.id = 'cyou_public_js';
      script.setAttribute('options', JSON.stringify(this.navConfig));
      document.head.appendChild(script);
    }
  }
};
</script>

<style scoped>
.nav-container {
  position: relative;
  z-index: 1000;
}
</style>